import React from 'react';
import { toast } from 'react-toastify';
import { Box, Button, ButtonGroup, Container, Paper } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';

export default function EncryptPasswords() {

  const encryptPasswords = async (event) => {
    
    event.preventDefault();
    const response = await fetch(`${process.env.REACT_APP_API}/users/encryptPasswords`, { method: 'GET' });

    const result = await response.json();
    return result;      
    
  };

  const handleSubmit = async (event) => {
    try {
      const result = await encryptPasswords(event);
      
      if (result.message === 'Success') {
        
        // Show success toast
        toast.success('Passwords Encrypted', { autoClose: 3000 });

      } 
    } catch (error) {
      toast.error('Error Encrypting Passwords', { autoClose: 3000 });
    } 
  };

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
          <ClassificationBannerHeader></ClassificationBannerHeader>
          <PageHeader title="Encrypt Passwords"></PageHeader>
      </Box>
      <Box
        component={Paper}
        elevation={3}
        sx={{
          mx: 'auto',
          width: 400,
          bgcolor: '#000',
          p: 2,
          mt: 5,
        }}
      >
        <Box component="form" onSubmit={handleSubmit}>
            <ButtonGroup 
              size="small"
              variant="contained" 
              aria-label="Basic button group" 
              fullWidth
              sx={{ mt:2 }}
            >
              <Button
                type="submit"                      
                variant="contained"
                sx={{
                      bgcolor: '#303F9F',
                      textTransform: 'none',
                      alignSelf: 'flex-start',
                      mt: 1,
                      ml: 4,
                      '&:hover': {
                      bgcolor: '#303F9F',
                      },
                      '&:disabled': {
                      bgcolor: 'rgba(255, 255, 255, 0.12)',
                      },
                      width: '47%',
                  }}
              >
                {'Encrypt Passwords'}
              </Button>
            </ButtonGroup>
        </Box>
      </Box>
    </Container>
  );
}